module.exports = __webpack_public_path__ + "ci_vendor_datadog.268ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/ci_vendor_datadog.svg
// module id = ./src/_asset/sources/assets/images/@svg/ci_vendor_datadog.svg
// module chunks = main